export default __webpack_public_path__ + "static/media/mothy_gray.f028bb3c.svg";